"use client";

import AddLead from "../../data/crm/AddLead/index.jsx";

export default function AddLeadScreen() {
  return <AddLead />;
}
